import React, { useState } from "react";
import api from "../../api/axios";

const TeamMemberModal = ({ onClose, onSaved }) => {
  const [form, setForm] = useState({
    team_name: "",
    position: "",
    social_facebook: "",
    social_insta: "",
    social_linkedin: "",
  });
  const [image, setImage] = useState(null);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    const data = new FormData();
    Object.entries(form).forEach(([key, value]) =>
      data.append(key, value)
    );
    data.append("image", image);

    await api.post("companyblog/admin/team-members/", data);
    onSaved();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h5>Create Team Member</h5>

        <div className="row">
          <div className="col">
            <label>Name *</label>
            <input
              className="form-control"
              name="team_name"
              onChange={handleChange}
            />
          </div>

          <div className="col">
            <label>Position *</label>
            <input
              className="form-control"
              name="position"
              onChange={handleChange}
            />
          </div>
        </div>

        <label className="mt-3">Image *</label>
        <input
          type="file"
          className="form-control"
          onChange={(e) => setImage(e.target.files[0])}
        />
         <div style={{fontSize: "12px", marginTop: "6px", color: "#555",}}>
            Required dimension is <b>400 × 400 px</b>
          </div>

        <label className="mt-3">Facebook</label>
        <input className="form-control" name="social_facebook" onChange={handleChange} />

        <label className="mt-2">Instagram</label>
        <input className="form-control" name="social_insta" onChange={handleChange} />

        <label className="mt-2">LinkedIn</label>
        <input className="form-control" name="social_linkedin" onChange={handleChange} />

        <div className="mt-4 text-end">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            CLOSE
          </button>
          <button className="btn btn-primary" onClick={handleSubmit}>
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberModal;
